module.exports = __webpack_public_path__ + "static/media/content.bbd8a254.jpg";